import { type CSSProperties, useEffect, useMemo } from 'react';

export const useDynamicGoogleFont = (fontName: string) => {
  const style = useMemo(
    () =>
      ({
        fontFamily: fontName,
      }) satisfies CSSProperties,
    [fontName],
  );

  useEffect(() => {
    const link = document.createElement('link');
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontName)}&display=swap`;
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [fontName]);

  return { style };
};

export default useDynamicGoogleFont;
